require("./brokerCryptoModal.scss");
// @vendors
import { useRef } from "react";
import PropTypes from "prop-types";
// @components
import { CryptoModalHeader } from "./components/header/brokerCryptoModalHeader";
import { CryptoModalFooter } from "./components/footer/brokerCryptoModalFooter";
import useFocusTrap from "../hooks/useFocusTrap";
import useModalBodyScroll from "../hooks/useModalBodyScroll ";

const CryptoModal = ({ children, onPrimaryButtonClick, isOpen, title, onOpen, onClose }) => {
    const modalRef = useRef(null);

    useFocusTrap(isOpen, modalRef);
    useModalBodyScroll(isOpen, onOpen);

    if(!isOpen) {
        return null;
    }

    return (
        <div className="crypto-modal__overlay">
            <div className="crypto-modal__container" ref={modalRef}>
                <CryptoModalHeader title={title} onClose={onClose}/>
                {children}
                <CryptoModalFooter onPrimaryButtonClick={onPrimaryButtonClick} />
            </div>
        </div>
    );
};

CryptoModal.propTypes = {
    children: PropTypes.node,
    onPrimaryButtonClick: PropTypes.func.isRequired,
    onOpen: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired
};

export { CryptoModal };
